import React, {
    useState,
    useRef,
    useEffect,
    Fragment
} from 'react';
import { Chevron } from "./index";
import styled from "styled-components";

const Wrapper = styled.div`
    background: white;
`;

const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    border-bottom: ${props => props.borderBottom};
    padding: 20px;
    width: 100%
    cursor: pointer;
    height: 56px;
    background: ${props => props.background};
    color: ${props => props.color};
  
`;

const Description = styled.p`
    font-size: 1.33rem;
    line-height: 24px;
    font-weight: 500;
    margin-left: 16px;

    ${props => props.theme.mediaQueries.medium}{
        font-size: 0.8rem;
    };
`;

const Line = styled.div`
    width: 100%;
    border-bottom: 1px solid #4F525D;
    margin-bottom: 32px;
`

const Content = styled.div`
    max-height: ${props => props.isActive ? (parseInt(props.contentHeight) + 24)+'px' : '0'};
    overflow: hidden;
    margin-top: 0;
    width: 335px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: ${props => props.isActive ? '24px' : '0'};
    transition: all .3s ease .15s;

    ${props => props.theme.mediaQueries.medium}{
        width: 100%;
        padding-left: 16px;
        padding-right: 16px;
    };
`;

const P = styled.p`
    ${props => props.theme.mediaQueries.medium}{
        font-size: 0.7rem;
    };
`

const Accordion = ({
    accordionItems
}) => {
    const [isActive, setIsActive] = useState(accordionItems.map((item => item.isOpen? true : false)));//useState(false)
    const [contentHeight, setContentHeight] = useState([]);
    const contentRef = useRef();
    const wrapperRef = useRef();
    const headerWrapperId = useRef(accordionItems.map(() => React.createRef()));

    const smoothScroll = (scrollY) => {
        let i = scrollY || window.pageYOffset;
        if (i < wrapperRef.current.offsetTop) {
            setTimeout(() => {
                if (i > window.pageYOffset) {
                    window.scrollTo(0, i);
                }
                smoothScroll(i + 10)
            }, 10)
        }
    }

    const toggelAccordionItem = (index) => {
        isActive[index] ? isActive[index] = false : isActive[index] = true;
        setIsActive([...isActive.map((value, i) => {
            return i === index ? value :  false
        })])

        contentHeight[index] = contentRef.current.scrollHeight;
        setContentHeight([...contentHeight])

        //smoothScroll()
    }


    const headerBackground = (index) => {

        let isAllClose = isActive.every(v => v === false);
        return isAllClose? "#FFFFFF" : !isActive[index]? "#FFA500" : "#FFFFFF"

    }

    const headerFontIconColor = (index) => {

        let isAllClose = isActive.every(v => v === false);
        return isAllClose? "#2e2e35" : !isActive[index]? "#FFFFFF" : "#2e2e35"
        
    }

    const renderAccordions = (accordionItems) => {
        return accordionItems.map((item, index) => {
            return (
                <Wrapper 
                    key={index}
                    ref={wrapperRef}
                >
                    <HeaderWrapper
                        borderBottom={index === (accordionItems.length - 1) ? 'none' : '1px solid #E5E5E5'}
                        ref={headerWrapperId.current[index]}
                        onClick={() => toggelAccordionItem(index)}
                        background = {headerBackground(index) }
                        color = { headerFontIconColor(index) }
                    >
                        <Chevron width={20} height={20} fill={"transparent"} isActive={isActive[index]} stroke={headerFontIconColor(index)}/>
                        <Description>
                            {item.description}
                        </Description>  
                    </HeaderWrapper>

                    <Content
                        isActive={isActive[index]}
                        ref={contentRef}
                        contentHeight={contentHeight[index]}
                    >
                        <Line />
                        {/* <P>{item.content}</P> */}
                        {item.content}
                    </Content>
                </Wrapper>
            )
        })
    }
    return (
        <Fragment>
            {renderAccordions(accordionItems)}
        </Fragment>
    )
}

export default Accordion;